import {WPApi} from "../common/wp-api";
import "../common/jquery-functions"
import 'slick-slider';
import "../registration/index";
import * as firebase from "firebase";
import "firebase/auth";

const firebaseConfig = CONFIG.firebase_config;

if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}

const wp = new WPApi();

jQuery(document).ready(async ($) => {
    let user = firebase.auth().currentUser;
    if (user) {
        let token = await user.getIdToken();
        await displayIframe(token);
    } else {
        firebase.auth().onAuthStateChanged(async function (user) {
            if (user) {
                let token = await user.getIdToken();
                await displayIframe(token);
            }
        });
    }

    if (jQuery('.special-container.login .actions-container').length > 0) {
        jQuery('.special-container.login .actions-container a').on('click', function () {
            if (this.classList.contains('register-link')) {
                setTimeout(function () {
                    jQuery('#start').click();
                }, 100);
            } else if (this.classList.contains('login-link')) {
                setTimeout(function () {
                    jQuery('.already-has-user').click();
                }, 100);
            }
        })
    }

    async function displayIframe(token) {
        let divContainer = $('.special-container.iframe.row');
        let urlRequest = 'sport1/v1/fantasy-league/';
        let headers = {
            Authorization: `Bearer ${token}`
        };
        let response = await wp.get(urlRequest, headers);
        if (response.url) {
            let iframe = '<iframe src="' + response.url + '" height="609" width="1260" title="Fantasy League"></iframe>';
            divContainer.html('');
            divContainer.append(iframe);
            divContainer.fadeIn(200);
        }
    }

});
